// @ts-nocheck
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// import { renderRoutes } from 'react-router-config';
import { ClerkProvider, SignedIn, SignedOut, UserButton } from '@/auth/clerkShim'
import useOrganizationStore from '@store/organizationStore';
import useAdminStore from '@store/adminStore';
import Nav from '@components/Nav/Nav';
import AdminRail from '@components/Nav/AdminRail';
import { Button } from "@/components/ui/button"
import { CardTitle, CardDescription, CardHeader, CardContent, Card } from "@/components/ui/card"
import { useNavigate, useLocation, Link, useRoutes, Outlet } from 'react-router-dom';
import { useAuth, useUser, useClerk, useOrganization } from '@/auth/clerkShim'
import { deleteClerkAuthToken } from '@/utils/clerk';
import LeagueSelector from "@/components/LeagueSelector/LeagueSelector";
import HelpAssistant from "@/components/HelpAssistant/HelpAssistant";
import CommandPalette from "@/components/CommandPalette/CommandPalette";
import FeedbackDialog from "@/components/FeedbackDialog/FeedbackDialog";
import { startUsageTracker, trackPageView } from '@/utils/usageTracker';
import { startSessionRecorder } from '@/utils/sessionRecorder';
import PageClicksFooter from '@/components/PageClicksFooter';
import { Toaster } from "@/components/ui/toaster"
import { Separator } from "@/components/ui/separator"
import { Loader2, Search } from "lucide-react"
import { OPEN_COMMAND_PALETTE_EVENT } from '@components/Nav/navItems';
import { PageSkeleton } from '@/components/Page/PageSkeletons';

import helpers from '@/utils/helpers';
import './styles.css'; // Assuming styles.css is in the same directory

// (Removed a leftover module-level `VITE_CLERK_PUBLISHABLE_KEY` guard that threw
// on import. Clerk is gone, nothing here reads the key, and a build without that
// env var would have taken down the whole dashboard.)

function OrganizationLayout() {
  const [leagueName, setLeagueName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const { orgSlug, isSignedIn: isSignedInAuth, isLoaded: isLoadedAuth } = useAuth();
  const navigate = useNavigate();
  // INT-0009 rail mode: the Appearance page trades the 256px sidebar for a
  // slim icon rail so the desktop live preview gets the width. Desktop only —
  // Nav still renders (wrapped lg:hidden) so mobile keeps its hamburger.
  // useLocation (not window.location) so client-side navigation in/out of
  // the page flips the shell without a full reload. Waivers, Email
  // Templates, and Settings joined the rail cluster (owner 2026-09-11) —
  // same focused-surface treatment as Appearance.
  const railPathname = useLocation().pathname;
  const railMode = ['/admin/appearance', '/admin/waivers', '/admin/email-templates', '/admin/settings', '/admin/editor']
    .some((p) => railPathname.startsWith(p));
  const location = useLocation();
  const { user, isSignedIn } = useUser();

  // NOTE: do NOT gate this layout on a JS-readable cookie. It used to call
  // `getAdminCookie(() => signOut())` — a Clerk-era check for `clerk_admin_token`.
  // Nothing has written that cookie since Clerk was removed, and the session is
  // now the **httpOnly** `atoken`, which JavaScript cannot read by design. So the
  // callback fired on every mount and signed the admin straight back out:
  // login → dashboard → POST /admins/auth/logout (clearing `atoken`) → /sign-in.
  // Auth state comes from `useAuth()` only; the signed-out redirect below is the
  // single place that bounces to /sign-in.
  const { getOrganizationByName, organizations } = useOrganizationStore();
  const { organization, isLoaded: isLoadedOrg } = useOrganization();


  useEffect(() => {
    if (!isLoadedAuth || !isSignedInAuth || !isLoadedOrg) return;
    if (!organization || !organization.name) {
      navigate('/setup', { replace: true });
    }
  }, [isLoadedAuth, isSignedInAuth, isLoadedOrg, organization, navigate]);

  // Owner-only usage analytics beacon (fail-silent; see utils/usageTracker.ts).
  useEffect(() => { startUsageTracker(); }, []);
  useEffect(() => { trackPageView(location.pathname); }, [location.pathname]);
  // rrweb session recording, masked inputs (fail-silent; INT-0035).
  useEffect(() => { startSessionRecorder(); }, []);

  useEffect(() => {
    if (isLoadedAuth && !isSignedInAuth) {
      deleteClerkAuthToken();
      const ticket = new URLSearchParams(window.location.search).get('__clerk_ticket');
      window.location.href = ticket ? `/sign-up?__clerk_ticket=${ticket}` : '/sign-in';
    }
  }, [isLoadedAuth, isSignedInAuth, navigate]);

  useEffect(() => {
    if (isLoadedAuth && isSignedInAuth && isLoadedOrg && !orgSlug) {
      setIsLoading(false);
    }
  }, [isLoadedAuth, isSignedInAuth, isLoadedOrg, orgSlug]);

  // if (isSignedIn === false) {
  //   debugger;
  //   deleteClerkAuthToken();
  //   window.location.href = "/sign-in";
  // }

  const league = leagueName ? _.find(organizations, { name: leagueName.toLowerCase() }) : null;
  const { userId, isLoaded, getToken } = useAuth();
  const { getAdminByClerkId } = useAdminStore((state: any) => ({
    getAdminByClerkId: state.getAdminByClerkId(getToken),
  }));

  useEffect(() => {
    console.log('OrganizationLayout::leagueName', orgSlug, isSignedInAuth);
    if (isSignedInAuth && orgSlug) {
      setLeagueName(orgSlug);
      getOrganizationByName(orgSlug);
      setIsLoading(false);

      // Fetch admin data to populate the store for tours and other features
      if (userId) {
        getAdminByClerkId(userId, (adminResult) => {
          console.log('OrganizationLayout::admin loaded:', adminResult);
        });
      }
    }
  }, [isSignedInAuth, userId, orgSlug]);

  // Cold-load state while auth resolves: a skeleton of the real shell (sidebar
  // rail + page skeleton), not a spinner — the layout doesn't jump when the
  // real Nav and page mount.
  if (!isLoadedAuth || isLoading) {
    return (
      <div className="league-layout-container">
        <div className="league-layout-main">
          <div className="league-layout-content">
            <div
              className="fixed top-0 left-0 z-10 hidden h-screen w-64 border-r bg-card lg:block"
              aria-hidden="true"
            />
            <div className="league-layout-main-content">
              <main className="league-main-content">
                <div className="league-content-wrapper">
                  <PageSkeleton />
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={railMode ? 'league-layout-container league-layout-rail' : 'league-layout-container'}>
      <div className="league-layout-main">
        <div className="league-layout-content">
          {railMode && <AdminRail />}
          <div className={railMode ? 'lg:hidden' : undefined}>
          <Nav league={league}>
            {/* <div className="nav-footer">
              <div className="nav-powered-by">
                <div className="powered-by-text">Powered by</div>
                <Link
                  to="/admin/create-app"
                  className="powered-by-link"
                >
                  <img
                    src={'https://staty-bucket.sfo2.cdn.digitaloceanspaces.com/images/white_logo.png'}
                    width={80}
                    height={12}
                    alt="Logo"
                    className="powered-by-logo"
                  />
                </Link>
              </div>
            </div> */}
          </Nav>
          </div>

          <div className="league-layout-main-content">
            <header className="league-header">
              <div className="league-header-content">
                <div className="league-info">
                  <div className="league-selector-container">
                    <LeagueSelector league={league} />
                  </div>
                  {/* The selector already names the org — no duplicate H1.
                      Page titles belong to each page's PageHeader. */}
                  {!league && (
                    <div className="league-info-loading">
                      <Loader2 className="loading-spinner-small" />
                      <span>Loading league information...</span>
                    </div>
                  )}
                </div>
                <div className="league-header-actions">
                  {/* Topbar search — same ⌘K palette the sidebar button opens. */}
                  <button
                    type="button"
                    onClick={() => window.dispatchEvent(new CustomEvent(OPEN_COMMAND_PALETTE_EVENT))}
                    className="hidden h-9 w-64 items-center gap-2 rounded-md border bg-card px-3 text-sm text-muted-foreground transition-colors hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:flex"
                  >
                    <Search className="h-4 w-4" aria-hidden="true" />
                    <span className="flex-1 truncate text-left">Search or jump to…</span>
                    <kbd className="rounded border bg-muted px-1.5 py-0.5 font-sans text-[0.6875rem] font-medium text-muted-foreground">
                      ⌘K
                    </kbd>
                  </button>
                  <SignedIn>
                    <UserButton 
                      afterSignOutUrl='/sign-in'
                      appearance={{
                        elements: {
                          avatarBox: "w-8 h-8"
                        }
                      }}
                    />
                  </SignedIn>
                  <SignedOut>
                    <Button variant="outline" asChild>
                      <Link to="/sign-in">Sign In</Link>
                    </Button>
                  </SignedOut>
                </div>
              </div>
            </header>

            <Separator className="league-separator" />

            <main className="league-main-content">
              <div className="league-content-wrapper">
                {league && <Outlet context={{ league, leagueName: leagueName || '' }}/>}
                {/* Owner-only "+" click-analytics footer — must stay the LAST
                    in-flow element on every admin page (CLAUDE.md → Admin
                    usage tracking; INT-0034). */}
                <PageClicksFooter />
                {league && <HelpAssistant league={league} />}
                {league && <CommandPalette league={league} leagueName={leagueName || ''} />}
                <FeedbackDialog />
                <Toaster />
              </div>
            </main>
          </div>
        </div>
      </div>
      
    </div>
  );
}

OrganizationLayout.propTypes = {
  route: PropTypes.object.isRequired,
};

export default OrganizationLayout;
